<template lang="html">
	<wizard-screen
		:completed="3"
		:total="5"
	>
		<h2>Recommended Features</h2>
		<div class="omapi-happy-text">
			Based on your selection, we recommend enabling the following features:
		</div>

		<div class="omapi-feature-group">
			<wizard-feature
				v-for="feature in features"
				:key="feature.slug"
				:feature="feature"
			/>
		</div>

		<template v-slot:after-card>
			<div class="omapi-text-center">
				<small v-if="pluginsList" class="omapi-will-be-installed">
					The following plugins will be installed for free:
					{{ pluginsList }}
				</small>
			</div>
			<wizard-exit/>
		</template>
	</wizard-screen>
</template>

<script lang="js">
import { featureMap } from '@/wizard/data'
import { mapGetters } from 'vuex'

export default {
	data () {
		return {
			featureMap,
		}
	},
	computed : {
		...mapGetters('wizard', [ 'inExtraFeatures' ]),
		...mapGetters([ 'onboardingUsage' ]),
		features () {
			return this.featureMap.filter(f => {
				return f.usage
					? f.usage === this.onboardingUsage
					: true
			})
		},
		pluginsList () {
			const list = this.featureMap.filter(f => {
				return f.plugin && this.inExtraFeatures(f.slug)
			}).map(f => {
				return f.plugin.title
			})

			return list.length ? list.join(', ') : ''
		},
	},
}
</script>
